export const SELECT_PRODUCT_LIFE_PROTECT_PLUS = 'SELECT_PRODUCT_LIFE_PROTECT_PLUS'

export const selectProductLifeProtectPlus = (productCode) => ({
  type: SELECT_PRODUCT_LIFE_PROTECT_PLUS,
  payload: productCode,
})

export const SELECT_BASIC_PLAN = 'SELECT_BASIC_PLAN'
export const selectBasicPlan = (product) => ({
  type: SELECT_BASIC_PLAN,
  payload: product,
})

export const UPDATE_BOOSTER_SA = 'UPDATE_BOOSTER_SA'
export const updateBoosterSA = (boosterSA) => ({
  type: UPDATE_BOOSTER_SA,
  payload: boosterSA,
})

export const SELECTED_BOOSTER_PLAN = 'SELECTED_BOOSTER_PLAN'
export const selectedBoosterPlan = (boosterPlan) => ({
  type: SELECTED_BOOSTER_PLAN,
  payload: boosterPlan,
})
